module.exports = __webpack_public_path__ + "img/1558276593.77cc1dcb.jpg";